import React from 'react'
// import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { getActiveRules } from 'ducks/styles'
import { showTab } from '../../../common/util'

  /**
   * Formats field names for better readability
   * @param {string} field - The field name to format
   * @returns {string} Formatted field name
   */
  const formatFieldName = (field) => {
    if(!field) return ''
    return field
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (l) => l.toUpperCase())
  }

  // TODO - check against possible predicates
  const formatPredicate = (predicate) => {
    const predicateMap = {
      'is':                    'is',
      'is_not':                'is not',
      'contains':              'contains',
      'starts_with':           'starts with',
      'ends_with':             'ends with',
      'greater_than':          '>',
      'less_than':             '<',
      'greater_than_or_equal': '≥',
      'less_than_or_equal':    '≤',
      'gte':                   '≥',
      'gt':                    '>',
      'lte':                   '≤',
      'lt':                    '<',
    }
    return predicateMap[predicate] || predicate
  }

  // TODO - use known filter labels
  const formatValue = (value) => {
    if(value === undefined || value === null) return null
    if(typeof value !== 'string') return value
    return value
      ?.toLowerCase()
      ?.replace(/\b\w/g, (l) => l.toUpperCase())
  }
  const MapStylesLegend = () => {
  const activeRules = useSelector(getActiveRules)

  // Don't render if no active rules
  if(!activeRules || activeRules.length === 0) {
    return null
  }



  const openStylesTab = (e) => {
    e.preventDefault()
    e.stopPropagation()
    showTab('#map-nav-style')
  }

  return (
    <div className="map-legend">
      <div className="map-legend-content">
        {activeRules.map((rule, index) => {
          // Build the style object for the swatch
          const swatchStyle = {
            backgroundColor: rule?.fill || 'transparent',
            border:          rule?.line
              ? `3px solid ${rule.line}`
              : '1px solid black'
          }

          return (
            <div key={index} className="legend-style-item">
              <div className="legend-color-indicators">
                <div
                  className="legend-color-swatch"
                  style={swatchStyle}
                  title={`Fill: ${rule?.fill || 'transparent'}, Border: ${rule?.line || 'black'}`}
                  onClick={openStylesTab}
                />
              </div>
              <div className="legend-label">
                <span className="legend-field">{formatFieldName(rule.field)}</span>{' '}
                <code className="legend-predicate pre bold">{formatPredicate(rule.predicate)}</code><br />{' '}
                <span className="legend-value subtle">{formatValue(rule.value)}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default MapStylesLegend